const isNullOrUndefined = (source) => source === null || source === undefined

const waitFor = (ms) => {
  let executionId = 1
  const executions = {}

  return (cb) => {
    const current = executionId
    const previous = executionId - 1

    if (executions[previous]) {
      clearTimeout(executions[previous])
      delete executions[previous]
    }

    const execution = setTimeout(() => {
      try {
        cb()
      } finally {
        clearTimeout(executions[current])
      }
    }, ms)

    executions[executionId] = execution
    executionId += 1
  }
}

const _isArray = (source) => Array.isArray(source)
const _isObject = (source) =>
  !isNullOrUndefined(source) && typeof source === 'object' && !_isArray(source)

const deepCopy = (src, dest) => {
  if (!dest) {
    return src
  }

  const isObject = _isObject(dest)
  for (const name in src) {
    let value = src[name]
    if (_isObject(value) && isObject) {
      value = deepCopy(value, dest[name])
    } else if (_isArray(value) && isObject) {
      value = deepCopy(value, dest[name])
    } else if (isObject) {
      value = isNullOrUndefined(dest[name]) ? value : dest[name]
    }
    dest[name] = value
  }
  return dest
}

export { waitFor, deepCopy, isNullOrUndefined }
